import { render, staticRenderFns } from "./OrganizationDetailMixin.vue?vue&type=template&id=4f06c7d7&"
import script from "./OrganizationDetailMixin.vue?vue&type=script&lang=js&"
export * from "./OrganizationDetailMixin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports